import client from '@/graphql/client'
import ListOrgProjects from '@/graphql/queries/ListOrgProjects'

// Org-native project list, cached per org. Projects are listed by ORG membership
// (listOrgProjects — every org member, incl. VIEWERs, sees all the org's projects),
// NOT by the legacy per-project TeamMember/projectMemberships list which is null for
// org users until a create/update populates it. Consumers that need "the projects in
// my current org" (nav New-workflow picker, clone-target menu, workspace grids) should
// read this store instead of the legacy list.
export const orgProjects = {
  namespaced: true,
  state: {
    // orgId -> Project[] (raw listOrgProjects shape: { id, name, organisationId, workflows })
    byOrg: {}
  },
  mutations: {
    setOrgProjects (state, { orgId, projects }) {
      state.byOrg = { ...state.byOrg, [orgId]: projects || [] }
    }
  },
  actions: {
    // Load (and cache) the current member-visible projects for an org. Pass force:true
    // to bypass the cache after a create/delete.
    async loadOrgProjects ({ commit, state }, { orgId, force = false } = {}) {
      if (!orgId) {
        return []
      }
      if (!force && state.byOrg[orgId]) {
        return state.byOrg[orgId]
      }
      try {
        const { listOrgProjects } = await client.query({
          operationName: 'listOrgProjects',
          query: ListOrgProjects,
          variables: { orgId }
        })
        const projects = listOrgProjects || []
        commit('setOrgProjects', { orgId, projects })

        return projects
      } catch (e) {
        console.error('loadOrgProjects failed', e)

        return []
      }
    }
  },
  getters: {
    projectsForOrg: (state) => (orgId) => state.byOrg[orgId] || [],
    // The { id, project } shape legacy consumers (cards / pickers) already expect.
    membershipsForOrg: (state) => (orgId) =>
      (state.byOrg[orgId] || []).map((project) => ({ id: project.id, project })),
    currentOrgProjects: (state, getters, rootState) =>
      getters.projectsForOrg(rootState.currentOrg.currentOrgId),
    currentOrgMemberships: (state, getters, rootState) =>
      getters.membershipsForOrg(rootState.currentOrg.currentOrgId)
  }
}
